import { render, staticRenderFns } from "./overallRankingDetail.vue?vue&type=template&id=58d3ab6e&scoped=true"
import script from "./overallRankingDetail.vue?vue&type=script&lang=js"
export * from "./overallRankingDetail.vue?vue&type=script&lang=js"
import style0 from "./overallRankingDetail.vue?vue&type=style&index=0&id=58d3ab6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3ab6e",
  null
  
)

export default component.exports